<div class="example-container">
    <div class="form-container">
        <form [formGroup]="form" (submit)="submit()">
            <ng-container *ngIf="DATA">
                <ng-container *ngFor="let property of OPTIONS.properties; let i = index">
                    <ng-container [ngSwitch]="property?.type">
                        <!-- normal Label -->
                        <div *ngSwitchCase="'label'">
                            {{ property.name }}:
                            {{ DATA[property.property] ? DATA[property.property] : '' }}
                        </div>
                        <div *ngSwitchDefault>
                            <!-- Skip -->
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngFor="let property of OPTIONS.properties; let i = index">
                <ng-container [ngSwitch]="property?.type">
                    <!-- normal Label -->
                    <div *ngSwitchCase="'label'">
                        <!-- Skip -->
                        <!-- Only Display Hidden -->
                        <input matInput hidden formControlName="{{ property.property }}" [id]="property.property" />
                    </div>

                    <!-- normal Text -->
                    <div *ngSwitchCase="'text'">
                        <aum-input
                            [aumFormControl]="form.controls[property.property]"
                            placeholder="{{ property.name }}..."
                        >
                            <aum-form-field-label>{{ property.name }}</aum-form-field-label>
                            <aum-form-error>
                                <span *ngIf="form.controls[property.property].errors?.['minlength']">
                                    {{
                                        getMinimumLengthErrorText(
                                            form.controls[property.property].errors['minlength']['requiredLength']
                                        )
                                    }}
                                </span>
                                <span *ngIf="form.controls[property.property].errors?.['required']">{{
                                    mandatoryText
                                }}</span>
                                <span *ngIf="form.controls[property.property].errors?.['pattern']">{{
                                    invalidText
                                }}</span>
                            </aum-form-error>
                        </aum-input>
                    </div>

                    <!-- long Text -->
                    <div *ngSwitchCase="'longtext'">
                        <aum-textarea
                            [aumFormControl]="form.controls[property.property]"
                            placeholder="{{ property.name }}..."
                        >
                            <aum-form-field-label>{{ property.name }}</aum-form-field-label>
                            <aum-form-error>
                                <span *ngIf="form.controls[property.property].errors?.['minlength']">
                                    {{
                                        getMinimumLengthErrorText(
                                            form.controls[property.property].errors['minlength']['requiredLength']
                                        )
                                    }}
                                </span>
                                <span *ngIf="form.controls[property.property].errors?.['required']">{{
                                    mandatoryText
                                }}</span>
                                <span *ngIf="form.controls[property.property].errors?.['pattern']">{{
                                    invalidText
                                }}</span>
                            </aum-form-error>
                        </aum-textarea>
                    </div>

                    <!-- Markup Text -->
                    <div *ngSwitchCase="'markup'">
                        <!-- TODO create custom MatFormFiled for Markup Text -->
                        <!-- TODO https://material.angular.io/components/form-field/overview#custom-form-field-controls -->

                        <quill-editor
                            [preserveWhitespace]="true"
                            #singleEditor
                            formControlName="{{ property.property }}"
                            [id]="property.property"
                            [modules]="toolbarOptions"
                            [sanitize]="true"
                        >
                        </quill-editor>
                        <mat-error
                            *ngIf="form.controls[property.property].touched && form.controls[property.property].invalid"
                        >
                            <span *ngIf="form.controls[property.property].errors['required']">{{ mandatoryText }}</span>
                            <span *ngIf="form.controls[property.property].errors['pattern']">{{ invalidText }}</span>
                        </mat-error>
                    </div>

                    <!-- Markup Text -->
                    <div *ngSwitchCase="'translatable-markup'">
                        <!-- TODO create custom MatFormFiled for Markup Text -->
                        <!-- TODO https://material.angular.io/components/form-field/overview#custom-form-field-controls -->
                        <mat-tab-group>
                            <mat-tab *ngFor="let lang of property.languages" label="{{ lang }}">
                                <ng-template matTabContent>
                                    <quill-editor
                                        [preserveWhitespace]="true"
                                        #multipleEditors
                                        formControlName="{{ property.property }}-{{ lang }}"
                                        id="{{ property.property }}-{{ lang }}"
                                        [modules]="toolbarOptions"
                                        [sanitize]="true"
                                        [styles]="{ height: '200px' }"
                                        [ngModel]="DATA[property.property][lang]"
                                    >
                                    </quill-editor>
                                </ng-template>

                                <aum-form-error>
                                    <span
                                        class="error-message"
                                        *ngIf="
                                            form.controls[getPropertyName(property.property, lang)].errors?.['required'] &&
                                            showDialogErrors
                                        "
                                    >
                                        {{ mandatoryText }}
                                    </span>
                                </aum-form-error>
                            </mat-tab>
                        </mat-tab-group>
                    </div>

                    <!-- Translatable Text -->
                    <div *ngSwitchCase="'translatable-text'">
                        <!-- TODO create custom MatFormFiled for Markup Text -->
                        <!-- TODO https://material.angular.io/components/form-field/overview#custom-form-field-controls -->
                        <mat-tab-group>
                            <mat-tab *ngFor="let lang of property.languages" label="{{ lang }}">
                                <aum-input
                                    [aumFormControl]="form.controls[property | keyFor : lang]"
                                    placeholder="{{ property.name }}..."
                                >
                                    <aum-form-field-label>{{ property.name }}</aum-form-field-label>
                                    <aum-form-error>
                                        <span *ngIf="form.controls[property | keyFor: lang].errors?.['required']"
                                            >{{ mandatoryText }}
                                        </span>
                                        <span *ngIf="form.controls[property | keyFor: lang].errors?.['pattern']">{{
                                            invalidText
                                        }}</span>
                                    </aum-form-error>
                                </aum-input>
                                <!--<mat-form-field class="form-field" appearance="outline">
                  <mat-label> {{ property.name }} </mat-label>
                  <input
                    matInput
                    formControlName="{{ property | keyFor: lang }}"
                    [id]="property | keyFor: lang"
                    required="{{ property.required }}"
                  />
                  <mat-error
                    *ngIf="
                      form.controls[property | keyFor: lang].touched &&
                      form.controls[property | keyFor: lang].invalid
                    "
                  >
                    <span
                      *ngIf="
                        form.controls[property | keyFor: lang].errors.required
                      "
                      >{{ getMandatoryText() }}</span
                    >
                    <span
                      *ngIf="
                        form.controls[property | keyFor: lang].errors.pattern
                      "
                      >{{ getInvatlidText() }}</span
                    >
                  </mat-error>
                </mat-form-field>-->
                            </mat-tab>
                        </mat-tab-group>
                    </div>

                    <!-- Select -->
                    <div *ngSwitchCase="'select'">
                        <aum-select
                            [aumFormControl]="form.controls[property.property]"
                            placeholder="{{ property.optionsLabel ? property.optionsLabel : property.name }}..."
                            [compareWith]="compareObjects"
                            [options]="property.options"
                            multiple="{{ property.multiple }}"
                            [id]="property.property"
                        >
                            <aum-form-field-label>{{ property.name }}</aum-form-field-label>
                            <aum-form-error>
                                <span *ngIf="form.controls[property.property].errors?.['required']">{{
                                    mandatoryText
                                }}</span>
                                <span *ngIf="form.controls[property.property].errors?.['pattern']">{{
                                    invalidText
                                }}</span>
                            </aum-form-error>
                        </aum-select>
                    </div>
                    <!-- Dragabble Multi Select -->

                    <div *ngSwitchCase="'draggable-multi-select'">
                        <aum-draggable-multi-select
                            [options]="property.options"
                            [placeholder]="property.name"
                            [aumFormControl]="form.controls[property.property]"
                        >
                            <aum-form-field-label>{{ property.name }}</aum-form-field-label>
                            <aum-form-error>
                                <span *ngIf="form.controls[property.property].errors?.['required']">{{
                                    mandatoryText
                                }}</span>
                            </aum-form-error>
                        </aum-draggable-multi-select>
                    </div>
                    <!-- Date -->
                    <div *ngSwitchCase="'date'">
                        <mat-form-field class="form-field" appearance="outline">
                            <mat-label>{{ property.name }}</mat-label>
                            <input matInput [matDatepicker]="dp" formControlName="{{ property.property }}" />
                            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                            <mat-datepicker #dp></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <!-- Switch (boolean) -->
                    <div *ngSwitchCase="'switch'">
                        <!-- TODO create custom MatFormFiled for switch-->
                        <mat-slide-toggle
                            formControlName="{{ property.property }}"
                            [id]="property.property"
                            required="{{ property.required }}"
                        >
                        </mat-slide-toggle>
                        <mat-label> {{ property.name }} </mat-label>
                    </div>

                    <!-- Checkbox (boolean) -->
                    <div *ngSwitchCase="'checkbox'">
                        <!-- TODO create custom MatFormFiled for checkbox-->
                        <mat-checkbox
                            [id]="property.property"
                            formControlName="{{ property.property }}"
                            required="{{ property.required }}"
                        ></mat-checkbox>
                        <mat-label> {{ property.name }} </mat-label>
                    </div>

                    <!-- Radio -->
                    <div *ngSwitchCase="'radio'">
                        <!-- TODO create custom MatFormFiled for radio-->
                        <mat-label>{{ property.name }}: </mat-label>
                        <mat-radio-group formControlName="{{ property.property }}">
                            <mat-radio-button
                                *ngFor="let radioOption of property.options"
                                [id]="radioOption.id"
                                [value]="radioOption"
                                required="{{ property.required }}"
                            >
                                {{ radioOption.name }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div *ngSwitchDefault>NO FORM FIELD DEFINED FOR {{ property.type }}</div>
                </ng-container>
            </ng-container>
            <div *ngIf="OPTIONS.properties.length === 0">
                <p>No properties defined</p>
            </div>
            <ng-content select="[extra-fields]"></ng-content>
            <ng-container *ngIf="OPTIONS.properties.length > 0">
                <div class="submit-box">
                    <button aum-button class="me-3" color="primary" type="submit" [disabled]="disableSubmitButton">
                        {{ submitText }}
                    </button>
                    <ng-content></ng-content>
                </div>
            </ng-container>
        </form>
    </div>
</div>
